module.exports = __webpack_public_path__ + "media/images/icons/video-26d9dd4b069d71ad7677bdbc42828c02.svg";